import { AlertIcon, BoltIcon, DocumentIcon, GaugeIcon, GearIcon, GlobeIcon, PlugIcon, ShieldIcon, SparkIcon, TrendIcon } from '@/components/icons';

export function workspacePresentation(path: string) {
  const parts = path.split('/').filter(Boolean);
  const area = parts[0] === 'sites' ? parts[1] === 'new' ? 'onboarding' : parts.length === 1 ? 'portfolio' : parts[2] ?? 'overview' : parts[0] ?? 'workspace';
  const items = {
    overview: { label: 'WEBSITE INTELLIGENCE', icon: GaugeIcon },
    issues: { label: 'AUDIT & EVIDENCE', icon: AlertIcon },
    reports: { label: 'YOUR WEBSITE STORY', icon: DocumentIcon },
    opportunities: { label: 'YOUR NEXT BEST MOVES', icon: TrendIcon },
    keywords: { label: 'SEARCH & CONTENT STRATEGY', icon: TrendIcon },
    roadmap: { label: 'A CLEAR PATH FORWARD', icon: SparkIcon },
    pages: { label: 'EXPLORE YOUR WEBSITE', icon: DocumentIcon },
    analysis: { label: 'EVIDENCE INTO DIRECTION', icon: SparkIcon },
    actions: { label: 'REVIEW. APPROVE. VERIFY.', icon: ShieldIcon },
    'search-setup': { label: 'CONNECT YOUR SEARCH STORY', icon: PlugIcon },
    settings: { label: parts[0] === 'sites' ? 'YOUR WEBSITE, YOUR RULES' : 'YOUR WORKSPACE, ORGANISED', icon: GearIcon },
    integrations: { label: 'A CONNECTED WORKSPACE', icon: PlugIcon },
    onboarding: { label: 'YOUR NEXT CHAPTER', icon: GlobeIcon },
    portfolio: { label: 'YOUR WEBSITE PORTFOLIO', icon: GlobeIcon },
    billing: { label: 'ROOM TO GROW', icon: BoltIcon },
    admin: { label: 'PLATFORM OPERATIONS', icon: ShieldIcon },
  };
  return { area, ...(items[area as keyof typeof items] ?? { label: 'YOUR COMMAND CENTER', icon: GaugeIcon }) };
}

